var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.summary && _vm.summary.html)?_c('div',{staticClass:"C-article-info-summary",domProps:{"innerHTML":_vm._s(_vm.summary.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }